import React from "react";
import { Grid } from "@material-ui/core/";
import "./PDFs.scss";
import ImportHeader from "./images/import-customs-header.png";
import ImportStamp from "./images/import-customs-stamp.png";
import { PDFInput } from "../../../../components/FormInputs/FormInputs";

const customsInputs = [
  {
    label: (
      <span>
        Shipper |<span style={{ fontStyle: "italic" }}> Feladó:</span>
      </span>
    ),
    id: "shipper",
  },
  {
    label: (
      <span>
        Address |<span style={{ fontStyle: "italic" }}> Cím:</span>
      </span>
    ),
    id: "addressshipper",
  },
  {
    label: (
      <span>
        (VPID) EORI number |
        <span style={{ fontStyle: "italic" }}> EORI szám:</span>
      </span>
    ),
    id: "eori",
  },
  {
    label: (
      <span>
        EU VAT ID | <span style={{ fontStyle: "italic" }}> EU adószám:</span>
      </span>
    ),
    id: "euvat",
  },
  {
    label: (
      <span>
        Bankaccount-No |
        <span style={{ fontStyle: "italic" }}> Bankszámlaszám:</span>
      </span>
    ),
    id: "bankaccount",
  },
  {
    label: (
      <span>
        IBAN-No |<span style={{ fontStyle: "italic" }}> Iban szám:</span>
      </span>
    ),
    id: "bankaccount",
  },
  {
    label: (
      <span>
        Consignee |<span style={{ fontStyle: "italic" }}> Címzett:</span>
      </span>
    ),
    id: "consignee",
  },
  {
    label: (
      <span>
        Address |<span style={{ fontStyle: "italic" }}> Cím: </span>
      </span>
    ),
    id: "addressconsignee",
  },
  {
    label: (
      <span>
        Phone/FAX |<span style={{ fontStyle: "italic" }}> Telefon-fax:</span>
      </span>
    ),
    id: "phone",
  },
  {
    label: (
      <span>
        Description of the goods |
        <span style={{ fontStyle: "italic" }}> Árumegnevezés:</span>
      </span>
    ),
    id: "shipmentdescr",
  },
  {
    label: (
      <span>
        Customs tarif. |
        <span style={{ fontStyle: "italic" }}> Tarifa szám:</span>
      </span>
    ),
    id: "tarifnr",
  },
  {
    label: (
      <span>
        Cargo value |<span style={{ fontStyle: "italic" }}> Áruérték:</span>
      </span>
    ),
    id: "cargovalue",
  },
  {
    label: (
      <span>
        Colli |<span style={{ fontStyle: "italic" }}> Colli szám:</span>
      </span>
    ),
    id: "collinr",
  },
  {
    label: (
      <span>
        Incoterms |<span style={{ fontStyle: "italic" }}> Fuvarparitás:</span>
      </span>
    ),
    id: "incoterms",
  },
  {
    label: (
      <span>
        Gross weight |<span style={{ fontStyle: "italic" }}> Bruttó súly:</span>
      </span>
    ),
    id: "grossweight",
  },
];
const radioInputs = [
  { label: "Határozatra fizetés", id: "id1" },
  { label: "Halasztott engedély (száma", id: "id2" },
  { label: "Vámletét számlára történő fizetés", id: "id3" },
  { label: "Önadózási engedély (száma", id: "id4" },
  { label: "Áfa biztosítása alóli mentesség", id: "id5" },
  {
    label:
      "Import engedély | Növényeü.-i igazolvány | Állat eü-i igazolvány | Márkavédelmi engedély",
    id: "6",
  },
];

function ImportCustoms({ ...props }) {
  return (
    <div className="ImportCustomsContainer">
      <div>
        <img src={ImportHeader} alt="" />
        <div className="ImportCustomsContent" style={{ marginTop: 0 }}>
          <p style={{ fontSize: "16px", margin: 0 }}>
            This way we mandate Transemex Kft., to represent and execute import
            customs clearance for us.
          </p>
          <p
            style={{ fontStyle: "italic", fontSize: "14px", margin: "4px 0px" }}
          >
            Ezúton megbízzuk a Transemex Kft. mint a SKYU vám képviseletét, hogy
            készitse el részünkre az import vámkezelést.
          </p>
        </div>
        {customsInputs.map((input) => {
          return (
            <div style={{ paddingLeft: "20px", marginBottom: "0px" }}>
              <div className="ImportCustomsInput">
                <PDFInput
                  disabled
                  value={props.data[input.id]}
                  label={input.label}
                />
              </div>
            </div>
          );
        })}
        <div className="ImportCustomsContent" style={{ margin: "0px 30px" }}>
          <p style={{ fontSize: "14px", margin: 0 }}>
            Mode of customs clearance |
            <span style={{ fontStyle: "italic" }}>Vámkezelés módja </span>(A
            kívánt eljárást kérjük megjelölni szíveskedjen):
          </p>
          <input type="checkbox" checked={props.data.checkbox1} />
          <span style={{ fontSize: "14px" }}>Szabadforgalomba helyezés</span>
          <br />
          {radioInputs.map((input, i) => {
            return (
              <>
                <input
                  type="radio"
                  id={input.id}
                  onClick={(event) => {
                    console.log(event.target.checked);
                  }}
                  checked={props.data[input.id]}
                  style={{ marginLeft: "16px" }}
                />
                <span style={{ fontSize: "14px" }}>
                  {input.label}{" "}
                  {(input.id === "id2" && props.data[`${input.id}text`]) ||
                  (input.id === "id4" && props.data[`${input.id}text`])
                    ? `${props.data[`${input.id}text`]})`
                    : ""}
                </span>
                {i === 2 || i === 4 ? <br /> : null}
              </>
            );
          })}
          <div className="Row" style={{ position: "relative" }}>
            <input type="checkbox" checked={props.data.checkbox2} />
            <span style={{ fontSize: "14px" }}>Árutovábbítás</span>
            <PDFInput
              disabled
              value={props.data.forward}
              inputStyle={{ marginBottom: "2px", width: "20%" }}
              labelStyle={{
                padding: "0 0 2px 0",
                fontSize: "16px",
              }}
              label=" "
            />
            <div
              style={{ position: "absolute", left: "260px", fontSize: "14px" }}
            >
              Vámhivatalhoz
            </div>
          </div>
        </div>
        <div className="ImportCustomsContent" style={{ margin: "2px 30px" }}>
          <p style={{ fontSize: "14px", margin: "4px 0px" }}>
            The customs clearance assignment is filled out in accordance with
            the declaration and other documents handed in by the client. As long
            as the client holds no VPID No., our assignment covers the obtaining
            procedures of this customs-registry number as well. The order is
            valid until our company withdraw it.
          </p>
          <p
            style={{ fontStyle: "italic", fontSize: "14px", margin: "4px 0px" }}
          >
            A kitöltött vámkezelési megbízás a valóságnak megfelel, okmányokkal
            megegyező. Amennyiben a megbízó nem rendelkezik VPID számmal a
            megbízás kiterjed annak ügyintézésére is. A megbízás visszavonásig
            érvényes.
          </p>
        </div>
        <div
          className="ImportCustomsInput"
          style={{
            marginTop: "40px",
            width: "40%",
            paddingLeft: "20px",
            position: "absolute",
            bottom: "150px",
            left: "10px",
          }}
        >
          <PDFInput
            value={props.data.date}
            disabled
            label={
              <span>
                Date |<span style={{ fontStyle: "italic" }}> Dátum</span>
              </span>
            }
          />
        </div>
        <img src={ImportStamp} alt="" />
        <Grid
          container
          className="ImportCustomsContent"
          justify="space-between"
          style={{ width: "90%" }}
        >
          <Grid item>
            <p className="ItalicTorea NoMargin">
              Bank: HUF: 10101078-52370400-01005005
            </p>
          </Grid>
          <Grid item>
            <p className="ItalicTorea NoMargin">Adószám: 13712134-2-13</p>
          </Grid>
          <Grid item>
            <p className="ItalicTorea NoMargin">
              Cégjegyzék szám: 13-09-107821
            </p>
          </Grid>
        </Grid>
        <div className="ImportCustomsContent" style={{ textAlign: "center" }}>
          <p className="ItalicTorea NoMargin" style={{ fontWeight: "normal" }}>
            A Magyar Szállítmányozók Szövetsége által jóváhagyott "Magyar
            Általános Szállítmányozási Feltételek" alapján dolgozunk. -
            Közlekedési Közlöny 1990/46.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ImportCustoms;
